export default __webpack_public_path__ + "static/media/2.6a5e4c61.svg";